(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ── 四個世界的 SVG cursor 圖案 ── */
  const cursors = {
    // VOID — 哥特十字準心：外圓 + 四射線 + 中心小十字
    void: {
      label: 'VOID',
      color: '#a01515',
      svg: `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32" cy="32" r="28" stroke="#a01515" stroke-width="1" opacity="0.5"/>
        <circle cx="32" cy="32" r="18" stroke="#a01515" stroke-width="0.8" opacity="0.35"/>
        <line x1="32" y1="0"  x2="32" y2="14" stroke="#a01515" stroke-width="1.2"/>
        <line x1="32" y1="50" x2="32" y2="64" stroke="#a01515" stroke-width="1.2"/>
        <line x1="0"  y1="32" x2="14" y2="32" stroke="#a01515" stroke-width="1.2"/>
        <line x1="50" y1="32" x2="64" y2="32" stroke="#a01515" stroke-width="1.2"/>
        <line x1="22" y1="32" x2="42" y2="32" stroke="#a01515" stroke-width="0.7" opacity="0.6"/>
        <line x1="32" y1="22" x2="32" y2="42" stroke="#a01515" stroke-width="0.7" opacity="0.6"/>
        <circle cx="32" cy="32" r="2.5" fill="#a01515" opacity="0.9"/>
        <circle cx="32" cy="32" r="5" stroke="#a01515" stroke-width="0.8" opacity="0.5"/>
      </svg>`,
    },
    // REVERIE — 柔和花瓣：雙重曲線圓環 + 旋轉花瓣輪廓
    reverie: {
      label: 'REVERIE',
      color: '#c4856a',
      svg: `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32" cy="32" r="26" stroke="#c4856a" stroke-width="1" stroke-dasharray="4 3" opacity="0.6"/>
        <circle cx="32" cy="32" r="18" stroke="#c4856a" stroke-width="0.7" opacity="0.35"/>
        <ellipse cx="32" cy="18" rx="5" ry="10" stroke="#c4856a" stroke-width="0.8" opacity="0.45" transform="rotate(0 32 32)"/>
        <ellipse cx="32" cy="18" rx="5" ry="10" stroke="#c4856a" stroke-width="0.8" opacity="0.45" transform="rotate(60 32 32)"/>
        <ellipse cx="32" cy="18" rx="5" ry="10" stroke="#c4856a" stroke-width="0.8" opacity="0.45" transform="rotate(120 32 32)"/>
        <ellipse cx="32" cy="18" rx="5" ry="10" stroke="#c4856a" stroke-width="0.8" opacity="0.35" transform="rotate(30 32 32)"/>
        <ellipse cx="32" cy="18" rx="5" ry="10" stroke="#c4856a" stroke-width="0.8" opacity="0.35" transform="rotate(90 32 32)"/>
        <ellipse cx="32" cy="18" rx="5" ry="10" stroke="#c4856a" stroke-width="0.8" opacity="0.35" transform="rotate(150 32 32)"/>
        <circle cx="32" cy="32" r="3" fill="#c4856a" opacity="0.8"/>
      </svg>`,
    },
    // WRECK — 朋克 X 形：粗斜叉 + 撕裂感鋸齒邊 + 中心方塊
    wreck: {
      label: 'WRECK',
      color: '#e8000a',
      svg: `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="8"  y1="8"  x2="56" y2="56" stroke="#e8000a" stroke-width="2.5" stroke-linecap="square"/>
        <line x1="56" y1="8"  x2="8"  y2="56" stroke="#e8000a" stroke-width="2.5" stroke-linecap="square"/>
        <line x1="10" y1="6"  x2="58" y2="54" stroke="#e8000a" stroke-width="0.7" opacity="0.35" stroke-linecap="square"/>
        <line x1="58" y1="6"  x2="10" y2="54" stroke="#e8000a" stroke-width="0.7" opacity="0.35" stroke-linecap="square"/>
        <rect x="27" y="27" width="10" height="10" fill="#e8000a" opacity="0.9"/>
        <rect x="25" y="25" width="14" height="14" stroke="#e8000a" stroke-width="0.8" opacity="0.4"/>
        <line x1="32" y1="2"  x2="32" y2="10" stroke="#e8000a" stroke-width="1" opacity="0.5"/>
        <line x1="32" y1="54" x2="32" y2="62" stroke="#e8000a" stroke-width="1" opacity="0.5"/>
        <line x1="2"  y1="32" x2="10" y2="32" stroke="#e8000a" stroke-width="1" opacity="0.5"/>
        <line x1="54" y1="32" x2="62" y2="32" stroke="#e8000a" stroke-width="1" opacity="0.5"/>
      </svg>`,
    },
    // AURUM — 奢華菱形：旋轉方形 + 精細格線 + 中心圓
    aurum: {
      label: 'AURUM',
      color: '#bfa040',
      svg: `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="32" y="6" width="37" height="37" rx="1" stroke="#bfa040" stroke-width="1" opacity="0.7" transform="rotate(45 32 32)"/>
        <rect x="32" y="14" width="26" height="26" rx="0.5" stroke="#bfa040" stroke-width="0.7" opacity="0.4" transform="rotate(45 32 32)"/>
        <line x1="32" y1="6"  x2="32" y2="18" stroke="#bfa040" stroke-width="0.8" opacity="0.6"/>
        <line x1="32" y1="46" x2="32" y2="58" stroke="#bfa040" stroke-width="0.8" opacity="0.6"/>
        <line x1="6"  y1="32" x2="18" y2="32" stroke="#bfa040" stroke-width="0.8" opacity="0.6"/>
        <line x1="46" y1="32" x2="58" y2="32" stroke="#bfa040" stroke-width="0.8" opacity="0.6"/>
        <circle cx="32" cy="32" r="4" stroke="#bfa040" stroke-width="1" opacity="0.8"/>
        <circle cx="32" cy="32" r="1.5" fill="#bfa040" opacity="1"/>
        <line x1="22" y1="22" x2="26" y2="26" stroke="#bfa040" stroke-width="0.6" opacity="0.35"/>
        <line x1="42" y1="22" x2="38" y2="26" stroke="#bfa040" stroke-width="0.6" opacity="0.35"/>
        <line x1="22" y1="42" x2="26" y2="38" stroke="#bfa040" stroke-width="0.6" opacity="0.35"/>
        <line x1="42" y1="42" x2="38" y2="38" stroke="#bfa040" stroke-width="0.6" opacity="0.35"/>
      </svg>`,
    },
  };

  /* ── 初始化 cursor ── */
  function initCursor() {
    if (reducedMotion || !hasHover) return;

    const el  = document.getElementById('yabi-cursor');
    const dot = document.getElementById('yabi-cursor-dot');
    const lbl = document.getElementById('yabi-cursor-label');
    if (!el) return;

    const bodyWorld = ['void','reverie','wreck','aurum'].find((world) => {
      return document.body.classList.contains(`yabi-theme-${world}`) ||
        document.querySelector(`.yabi-concept-world--${world}`) ||
        document.querySelector(`.icey-search--${world}`);
    });

    let mx = window.innerWidth / 2;
    let my = window.innerHeight / 2;
    let cx = mx, cy = my;
    let svgEl = null;
    let activeWorld = bodyWorld || null;

    if (activeWorld) document.body.setAttribute('data-yabi-panel', activeWorld);
    el.classList.add('is-visible');
    document.body.classList.add('yabi-custom-cursor');

    // Smooth follow
    (function raf() {
      cx += (mx - cx) * 0.16;
      cy += (my - cy) * 0.16;
      el.style.transform = `translate(${cx}px,${cy}px)`;
      requestAnimationFrame(raf);
    })();

    document.addEventListener('mousemove', (e) => {
      mx = e.clientX; my = e.clientY;
      el.classList.add('is-visible');
      if (activeWorld) setCursor(activeWorld);
    });
    document.addEventListener('mouseleave', () => el.classList.remove('is-visible'));

    function setCursor(world) {
      const def = cursors[world];
      if (!def) return clearCursor();
      if (activeWorld === world && svgEl) return;

      activeWorld = world;
      document.body.setAttribute('data-yabi-panel', world);
      el.classList.add('on-panel');

      // swap SVG
      if (svgEl) svgEl.remove();
      const wrap = document.createElement('div');
      wrap.innerHTML = def.svg;
      svgEl = wrap.firstElementChild;
      el.insertBefore(svgEl, el.firstChild);

      // label
      if (lbl) { lbl.textContent = def.label; lbl.style.color = def.color; }
    }

    function clearCursor() {
      if (bodyWorld) {
        activeWorld = null;
        setCursor(bodyWorld);
        return;
      }

      activeWorld = null;
      document.body.removeAttribute('data-yabi-panel');
      el.classList.remove('on-panel');
      if (svgEl) { svgEl.remove(); svgEl = null; }
      if (lbl) lbl.textContent = '';
    }

    if (activeWorld) setCursor(activeWorld);

    // 主頁四個 panel
    document.querySelectorAll('.panel.void, .panel.reverie, .panel.wreck, .panel.aurum').forEach((p) => {
      const world = ['void','reverie','wreck','aurum'].find(w => p.classList.contains(w));
      p.addEventListener('mouseenter', () => setCursor(world));
      p.addEventListener('mouseleave', clearCursor);
    });

    // 各世界頁按鈕 CTA
    [
      ['.yabi-concept-world--void', 'void'],
      ['.yabi-concept-world--reverie', 'reverie'],
      ['.yabi-concept-world--wreck', 'wreck'],
      ['.yabi-concept-world--aurum', 'aurum'],
    ].forEach(([sel, world]) => {
      document.querySelectorAll(`${sel} a, ${sel} button`).forEach((el) => {
        el.addEventListener('mouseenter', () => setCursor(world));
        el.addEventListener('mouseleave', clearCursor);
      });
    });
  }

  /* ── 主頁 intro + 四格展開 ── */
  function initHomePage() {
    const intro = document.getElementById('intro');
    if (intro) setTimeout(() => intro.classList.add('gone'), reducedMotion ? 0 : 1400);

    const stage = document.getElementById('stage');
    const panels = [...document.querySelectorAll('.panel[data-panel]')];
    if (!stage || !panels.length) return;

    const BIG = '65%', SML = '35%';
    const configs = {
      '1': { c1: BIG, c2: SML, r1: BIG, r2: SML },
      '2': { c1: SML, c2: BIG, r1: BIG, r2: SML },
      '3': { c1: BIG, c2: SML, r1: SML, r2: BIG },
      '4': { c1: SML, c2: BIG, r1: SML, r2: BIG },
    };
    panels.forEach((p) => {
      p.addEventListener('mouseenter', () => {
        const c = configs[p.dataset.panel]; if (!c) return;
        stage.style.setProperty('--c1', c.c1);
        stage.style.setProperty('--c2', c.c2);
        stage.style.setProperty('--r1', c.r1);
        stage.style.setProperty('--r2', c.r2);
      });
      p.addEventListener('mouseleave', () => {
        ['--c1','--c2','--r1','--r2'].forEach(v => stage.style.setProperty(v, '50%'));
      });
    });
  }

  /* ── 保留 preview_theme_id ── */
  function preservePreviewParam() {
    const pid = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (!pid) return;
    document.querySelectorAll('a[href^="/"]').forEach((a) => {
      try {
        const u = new URL(a.getAttribute('href'), location.origin);
        u.searchParams.set('preview_theme_id', pid);
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (_) {}
    });
  }

  function initCatalogNav() {
    const desktopGroups = [...document.querySelectorAll('.aurum-mega-nav__group')];
    const mobileMenus = [...document.querySelectorAll('.aurum-mobile-menu')];
    const mobileGroups = mobileMenus.flatMap((menu) => {
      return [...menu.querySelectorAll(':scope > .aurum-mobile-menu__panel > details')];
    });

    const closeDetails = (details) => {
      details.forEach((item) => {
        item.open = false;
      });
    };

    const makeExclusive = (groups, groupsToClose = []) => {
      groups.forEach((group) => {
        group.addEventListener('toggle', () => {
          if (!group.open) return;
          groups.forEach((other) => {
            if (other !== group) other.open = false;
          });
          closeDetails(groupsToClose);
        });
      });
    };

    makeExclusive(desktopGroups, mobileMenus);
    makeExclusive(mobileGroups, desktopGroups);

    mobileMenus.forEach((menu) => {
      menu.addEventListener('toggle', () => {
        if (menu.open) {
          closeDetails(desktopGroups);
          return;
        }
        closeDetails([...menu.querySelectorAll(':scope > .aurum-mobile-menu__panel > details')]);
      });
    });

    document.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.closest('.aurum-mega-nav, .aurum-mobile-menu')) return;
      closeDetails([...desktopGroups, ...mobileMenus, ...mobileGroups]);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openDetails = [...document.querySelectorAll('.aurum-mega-nav__group[open], .aurum-mobile-menu[open], .aurum-mobile-menu__panel > details[open]')];
      const focusTarget = openDetails.at(-1)?.querySelector(':scope > summary');
      closeDetails(openDetails);
      focusTarget?.focus();
    });
  }

  function init() {
    preservePreviewParam();
    initCursor();
    initHomePage();
    initCatalogNav();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
